import React from 'react';
import PredictionInput from './pages/PredictionInput';
import PredictionDetail from './pages/PredictionDetail';
import Settlement from './pages/Settlement';
import History from './pages/History';
import PublicPrompt from './pages/PublicPrompt';
import SettlementQueue from './pages/SettlementQueue';
import Analysts from './pages/Analysts';
export { configure } from './api';
export const routes = [{
  path: '/analyst-revision',
  component: <History />
}, {
  path: '/analyst-revision/settlement',
  component: <SettlementQueue />
}, {
  path: '/analyst-revision/analysts',
  component: <Analysts />
}, {
  path: '/analyst-revision/create',
  component: <PredictionInput />
}, {
  path: '/analyst-revision/prompts',
  component: <PublicPrompt />
}, {
  path: '/analyst-revision/predictions/:id',
  component: <PredictionDetail />
}, {
  path: '/analyst-revision/batches/:id/settlement',
  component: <Settlement />
}];
export const navigation = {
  id: 'analyst-revision',
  label: 'Analyst Revisions',
  icon: 'ri-user-star-line',
  link: '/analyst-revision'
};
export const publicNavigation = { label: 'Analyst Revisions', link: '/analyst-revision', group: 'AI modes' };
export function getNavigation({ admin, paid }) {
  return { ...navigation, subItems: [
    {id:'analyst-revision-history',label:'History',link:'/analyst-revision',parentId:navigation.id},
    ...(admin || paid ? [{id:'analyst-revision-analysts',label:'Analysts',link:'/analyst-revision/analysts',parentId:navigation.id}] : []),
    ...(admin ? [
      {id:'analyst-revision-input',label:'Prediction Input',link:'/analyst-revision/create',parentId:navigation.id},
      {id:'analyst-revision-settlement',label:'Settlement',link:'/analyst-revision/settlement',parentId:navigation.id},
    ] : []),
  ] };
}
